import { render, staticRenderFns } from "./DdMonthRangeBox.vue?vue&type=template&id=95e4da94&scoped=true&"
import script from "./DdMonthRangeBox.vue?vue&type=script&lang=js&"
export * from "./DdMonthRangeBox.vue?vue&type=script&lang=js&"
import style0 from "./DdMonthRangeBox.vue?vue&type=style&index=0&id=95e4da94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95e4da94",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
